export default __webpack_public_path__ + "images/db-logos/elasticsearch2.png";